import { render, staticRenderFns } from "./pembelian-card.vue?vue&type=template&id=21255216&scoped=true&"
import script from "./pembelian-card.vue?vue&type=script&lang=js&"
export * from "./pembelian-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21255216",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CImage: require('@chakra-ui/vue').CImage, CBox: require('@chakra-ui/vue').CBox, CText: require('@chakra-ui/vue').CText, CFlex: require('@chakra-ui/vue').CFlex})
